
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.692 14.248l.076.004a.75.75 0 010 1.493l-.076.004H5.308a.75.75 0 010-1.5h5.384zM7.25 12.845V9.077a.75.75 0 111.5 0v3.768a.75.75 0 01-1.5 0z","fill":"#4A4A4A"}}),_c('path',{attrs:{"d":"M9.623 6.393a.75.75 0 111.06 1.06L8.53 9.608a.75.75 0 01-1.06 0L5.316 7.454a.75.75 0 111.06-1.06L8 8.015l1.623-1.623z","fill":"#4A4A4A"}}),_c('path',{attrs:{"d":"M7.887 1.751c-2.507.058-4.534 2.15-4.52 4.66a4.63 4.63 0 001.776 3.621 2.375 2.375 0 01.915 1.87v.193h3.884v-.196a2.389 2.389 0 01.924-1.874 4.636 4.636 0 00-.246-7.463 4.64 4.64 0 00-2.733-.811zm3.555 10.556a1.289 1.289 0 01-1.288 1.288H5.847a1.288 1.288 0 01-1.29-1.288v-.403l-.004-.1a.872.872 0 00-.331-.587l-.001-.001a6.126 6.126 0 01-2.355-4.797l.001-.001C1.85 3.093 4.525.33 7.852.253a6.133 6.133 0 013.936 10.955l-.004.003a.886.886 0 00-.342.695v.4z","fill":"#4A4A4A"}})])
          )
        }
      }
    